import { Controller } from "stimulus";
import { slugify } from "../utils";

export default class extends Controller {
  declare sourceTarget: HTMLInputElement;
  declare slugTarget: HTMLInputElement;
  declare slugLabelTarget: HTMLElement;
  declare hasSlugLabelTarget: boolean;

  static get targets() {
    return ["source", "slug", "slugLabel"];
  }

  public sourceInput() {
    // Once the user has typed into the slug field, we don't
    // slugify the values anymore.
    // TODO: migrate from DataMaps to Values
    if (!this.data.has("slug-dirty")) {
      const slug = slugify(this.sourceTarget.value);
      this.setValue(this.slugTarget, slug);
    }
  }

  public slugInput(ev: Event) {
    const focused = document.activeElement === this.slugTarget;
    const originalSlug = this.slugTarget.value;
    const slugified = slugify(originalSlug);
    this.slugTarget.value = slugified;
    this.setSlugLabel(slugified);

    if (focused && this.slugTarget.selectionStart) {
      // If slugify hasn't changed the length of the slug then
      // the selectionStart will already be in the correct place
      // (it already moved when the input was made).
      // If the string length has changed, e.g. someone tried to type $,
      // or paste $a$, then we reset the selectionStart back to the position
      // it would have been if only legal letters were typed.
      const selectionStart = this.slugTarget.selectionStart;
      const cursorOffset = originalSlug.length - slugified.length;
      const newSelectionStart = selectionStart - cursorOffset;
      this.slugTarget.setSelectionRange(newSelectionStart, newSelectionStart);
    }
  }

  public slugChange(ev: Event) {
    // The change event is fired when there was a user actually typing in this field.
    // TODO: migrate from DataMaps to Values
    this.data.set("slug-dirty", "yes");
  }

  private setValue(input: HTMLInputElement, value: string) {
    input.value = value;
    // The second call here is because of Safari not hiding placeholder text:
    // http://stackoverflow.com/q/39624902/826486
    input.value = value;
    input.dispatchEvent(
      new Event("input", {
        bubbles: true,
      }),
    );
  }

  private setSlugLabel(slug: string) {
    if (this.hasSlugLabelTarget) {
      if (slug === "") {
        // TODO: migrate from DataMaps to Values
        this.slugLabelTarget.textContent = this.data.get("empty-label") || "";
      } else {
        this.slugLabelTarget.textContent = slug;
      }
    }
  }
}
